import { React, PT } from '@gasbuddy/react';
import { Header, Modal, Button, Form, Message } from 'semantic-ui-react';

export default class EditLinkDialog extends React.Component {
  state = {}

  render() {
    const { onCancel, onSubmit, defaultValue } = this.props;
    const { template } = this.state;

    return (
      <Modal
        open
      >
        <Header content="Edit Affiliate Link" />
        <Modal.Content>
          <div>
            <Message warning>
              You are editing a live system. Please make sure to use a link that includes
              the right placeholder values for us to send the GasBuddy user information or
              you will BREAK THIS CAMPAIGN. Any questions, ask a developer first.
            </Message>
            <Form.Input
              fluid
              label="Link Template"
              onChange={({ target: { value } }) => this.setState({ template: value })}
              value={template || defaultValue.template}
            />
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button basic color="grey" onClick={onCancel}>
            Cancel
          </Button>
          <Button basic color="red" onClick={() => onSubmit({ template })}>
            Change Link
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

EditLinkDialog.propTypes = {
  onCancel: PT.func.isRequired,
  onSubmit: PT.func.isRequired,
  defaultValue: PT.shape({}).isRequired,
};
